/**
 * Hook para buscar informações de auditoria de uma instância
 */
import { useQuery } from '@tanstack/react-query';
import { getInstanceAuditInfo } from '../services/instanceDetailService';
import { executionKeys } from '../keys';

export function useInstanceAudit(organizationId?: string, instanceId?: string) {
  const query = useQuery({
    queryKey: [...executionKeys.detail(organizationId ?? '', instanceId ?? ''), 'audit'],
    enabled: Boolean(organizationId && instanceId),
    queryFn: () => getInstanceAuditInfo(organizationId!, instanceId!),
    staleTime: 30_000,
  });

  return {
    audit: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
